import type { contractBook } from "@eulerxyz/core-sdk"
import type {
  BatchResultStatus,
  ContractFunctionResult,
} from "@eulerxyz/evc-sdk"
import { createSelector } from "@reduxjs/toolkit"
import { type Address, getAddress } from "viem"

type AccountVaultsResults = BatchResultStatus<
  ContractFunctionResult<
    typeof contractBook.accountLens.abi,
    "getVaultAccountInfo"
  >
>["result"]

export const mapAccountVaultsData = createSelector(
  [(vaults: AccountVaultsResults[]) => vaults],
  (vaults) => {
    const data = new Map<Address, AccountVaultsResults>()
    vaults.forEach((vault) => {
      if (!vault) return
      data.set(getAddress(vault.vault), vault)
    })

    return data
  },
)
